/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MinioObject } from '../models/minio-object';
import { UploadFileByPath } from '../models/upload-file-by-path';

@Injectable({
  providedIn: 'root',
})
export class MinioControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation minioControllerReUpdateFileAndDataOnce
   */
  static readonly MinioControllerReUpdateFileAndDataOncePath = '/fileupdate/reUpdateFileAndDataOnce/{module}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reUpdateFileAndDataOnce()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reUpdateFileAndDataOnce$Response(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerReUpdateFileAndDataOncePath, 'post');
    if (params) {
      rb.path('module', params.module, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reUpdateFileAndDataOnce$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reUpdateFileAndDataOnce(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<{
}> {

    return this.reUpdateFileAndDataOnce$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation minioControllerUpdateFileAndData
   */
  static readonly MinioControllerUpdateFileAndDataPath = '/fileupdate/updateFileAndData/{module}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFileAndData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateFileAndData$Response(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerUpdateFileAndDataPath, 'post');
    if (params) {
      rb.path('module', params.module, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFileAndData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateFileAndData(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<{
}> {

    return this.updateFileAndData$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation minioControllerFindFile
   */
  static readonly MinioControllerFindFilePath = '/findFile/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  findFile$Response(params: {
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'fileUrl'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerFindFilePath, 'get');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'fileUrl'?: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findFile(params: {
    url: string;
    context?: HttpContext
  }
): Observable<{
'fileUrl'?: string;
}> {

    return this.findFile$Response(params).pipe(
      map((r: StrictHttpResponse<{
'fileUrl'?: string;
}>) => r.body as {
'fileUrl'?: string;
})
    );
  }

  /**
   * Path part for operation minioControllerGetFiletest
   */
  static readonly MinioControllerGetFiletestPath = '/getFiletest/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFiletest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFiletest$Response(params: {
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerGetFiletestPath, 'get');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFiletest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFiletest(params: {
    url: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.getFiletest$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation minioControllerGetQuotAttach
   */
  static readonly MinioControllerGetQuotAttachPath = '/getQuotAttach/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQuotAttach()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuotAttach$Response(params: {
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerGetQuotAttachPath, 'get');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getQuotAttach$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuotAttach(params: {
    url: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.getQuotAttach$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation minioControllerDeleteByName
   */
  static readonly MinioControllerDeleteByNamePath = '/rohs-file/{model}/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteByName$Response(params: {
    model: string;
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerDeleteByNamePath, 'delete');
    if (params) {
      rb.path('model', params.model, {});
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteByName(params: {
    model: string;
    url: string;
    context?: HttpContext
  }
): Observable<any> {

    return this.deleteByName$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation minioControllerFileUpload
   */
  static readonly MinioControllerFileUploadPath = '/rohs-upload-file-stream';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Response(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
'file'?: Blob;
'bucketName'?: string;
'type'?: string;
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerFileUploadPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
'file'?: Blob;
'bucketName'?: string;
'type'?: string;
}
  }
): Observable<{
}> {

    return this.fileUpload$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation minioControllerGetFile
   */
  static readonly MinioControllerGetFilePath = '/sfe-file/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFile$Response(params: {
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerGetFilePath, 'get');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFile(params: {
    url: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.getFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation minioControllerUploadFileByPath
   */
  static readonly MinioControllerUploadFileByPathPath = '/sfe-upload-file-path';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFileByPath()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadFileByPath$Response(params?: {
    context?: HttpContext
    body?: UploadFileByPath
  }
): Observable<StrictHttpResponse<MinioObject>> {

    const rb = new RequestBuilder(this.rootUrl, MinioControllerService.MinioControllerUploadFileByPathPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MinioObject>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadFileByPath$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadFileByPath(params?: {
    context?: HttpContext
    body?: UploadFileByPath
  }
): Observable<MinioObject> {

    return this.uploadFileByPath$Response(params).pipe(
      map((r: StrictHttpResponse<MinioObject>) => r.body as MinioObject)
    );
  }

}
